import { render, staticRenderFns } from "./BannerSidebarAddPayment.vue?vue&type=template&id=6e98e5fb"
import script from "./BannerSidebarAddPayment.vue?vue&type=script&lang=js"
export * from "./BannerSidebarAddPayment.vue?vue&type=script&lang=js"
import style0 from "./BannerSidebarAddPayment.vue?vue&type=style&index=0&id=6e98e5fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports